// extracted by mini-css-extract-plugin
export default {"container":"CardContentComponent_container__-Eb24","subtitle":"CardContentComponent_subtitle__-MbL4","map":"CardContentComponent_map__RhUlo"};